import styles from 'styles/components/animatedDot.module.scss';

const AnimatedDot = () => (
  <div className={styles.ringContainer}>
    <div className={styles.ring}></div>
    <div className={styles.circle}></div>
  </div>
);

export default AnimatedDot;
